import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { SocialLinks } from './SocialLinks';

const SITE = 'https://cipherone.us';
const LINKS = [
  { label: 'Home', href: `${SITE}/` },
  { label: 'Services', href: `${SITE}/services` },
  { label: 'Industries', href: `${SITE}/industries` },
  { label: 'About', href: `${SITE}/about` },
  { label: 'Newsroom', href: `${SITE}/newsroom` },
  { label: 'In Development', href: `${SITE}/development` },
  { label: 'Support', href: `${SITE}/support` },
  { label: 'Contact', href: `${SITE}/contact` },
];
const ext = { target: '_blank', rel: 'noopener noreferrer' };

export const CorporateHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="corp-header w-full" data-testid="corporate-header">
      <div className="co-container corp-header-inner">
        <a href={`${SITE}/`} {...ext} className="corp-brand" title="CipherOne (opens cipherone.us in a new tab)">
          <img src="/cipherone-logo.png" alt="CipherOne" className="corp-logo" />
          <span className="corp-wordmark-block">
            <span className="corp-wordmark"><span className="corp-wordmark-cipher">Cipher</span><span className="corp-wordmark-one">One</span></span>
            <span className="corp-tagline">Technology. Solutions. A stronger tomorrow.</span>
          </span>
        </a>
        <nav className="corp-nav" aria-label="CipherOne company site">
          {LINKS.map((l) => (
            <a key={l.label} href={l.href} {...ext} className="corp-nav-link">{l.label}</a>
          ))}
        </nav>
        <div className="corp-header-actions">
          <a href={`${SITE}/support`} {...ext} className="corp-support" data-testid="corporate-support-cta">Get IT Support</a>
          <button className="corp-menu-toggle" onClick={() => setOpen(!open)} aria-label="Company site menu" aria-expanded={open} data-testid="corporate-company-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#193b4b] px-4 py-2" style={{ backgroundColor: 'rgba(2,11,17,.96)' }} data-testid="corporate-company-menu">
          <p className="text-[10px] uppercase tracking-wider text-[#5f7585] px-1 pb-1">Company site (cipherone.us)</p>
          <div className="flex flex-col">
            {LINKS.map((l) => (
              <a key={l.label} href={l.href} {...ext} className="text-sm text-[#b1c3ce] hover:text-[#37c9ee] py-2 border-b border-[#0e2733]">{l.label}</a>
            ))}
            <a href={`${SITE}/support`} {...ext} className="text-sm font-semibold mt-2 px-3 py-2 rounded-md bg-[#37c9ee] text-[#041019] text-center" data-testid="corporate-support-cta-mobile">Get IT Support</a>
          </div>
        </div>
      )}
    </header>
  );
};

export const CorporateFooter = () => (
  <footer className="w-full bg-[#020b11] border-t border-[#193b4b] mt-8" data-testid="corporate-footer">
    <div className="co-container py-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
        <div className="min-w-0">
          <p className="text-[#f4f8fa] font-semibold">CipherOne MSP, LLC</p>
          <p className="text-[#b1c3ce] mt-1">Mon&ndash;Fri 9 AM&ndash;5 PM Central</p>
        </div>
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-[#5f7585]">Contact</p>
          <a href="tel:+17135759514" className="block text-[#b1c3ce] hover:text-[#37c9ee] mt-1" style={{ whiteSpace: 'nowrap', wordBreak: 'normal', overflowWrap: 'normal' }} data-testid="footer-phone">713-575-9514</a>
          <a href="mailto:support@cipherone.us" className="block text-[#b1c3ce] hover:text-[#37c9ee] mt-1" style={{ whiteSpace: 'nowrap', wordBreak: 'normal', overflowWrap: 'normal' }} data-testid="footer-email">support@cipherone.us</a>
        </div>
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-[#5f7585]">Legal</p>
          <div className="flex flex-col mt-1">
            <a href={`${SITE}/privacy`} {...ext} className="text-[#b1c3ce] hover:text-[#37c9ee] py-0.5">Privacy</a>
            <a href={`${SITE}/terms`} {...ext} className="text-[#b1c3ce] hover:text-[#37c9ee] py-0.5">Website Terms</a>
            <a href={`${SITE}/newsroom`} {...ext} className="text-[#b1c3ce] hover:text-[#37c9ee] py-0.5" data-testid="footer-newsroom-link">Newsroom</a>
          </div>
        </div>
      </div>
      <div className="mt-6 pt-5 border-t border-[#0e2733] flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-[#5f7585]">Follow CipherOne</p>
          <SocialLinks tone="dark" className="-ml-2 mt-1" />
        </div>
        <p className="text-xs text-[#5f7585] sm:text-right">&copy; {new Date().getFullYear()} CipherOne MSP, LLC. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
